import i18next from "i18next";

const extractAreaFilterOptionsFromEntities = (entities, areaFilters) => {
    let filteredResponse = entities.map(entity => entity.areaTag)
                                   .filter(areaTag => areaTag != null)
                                   .filter((tag, index, allTags) => allTags.indexOf(allTags.find(at => at.id === tag.id)) === index);

    var areaFilterOptions = null

    if (areaFilters) {
        areaFilterOptions = filteredResponse.map(tag => ({id: tag.id, icon: null, className: '', name: tag.name, selected: areaFilters.includes(tag.id)}))
    } else {
        areaFilterOptions = filteredResponse.map(tag => ({id: tag.id, icon: null, className: '', name: tag.name, selected: true}))
    }

    areaFilterOptions.push({id: -1, icon: null, className: "", token: 'other', name: i18next.t('device-data-types.other'), selected: true});
    areaFilterOptions.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));

    return areaFilterOptions;
};

const containsID = (array, id) => {
    for (let i = 0; i < array.length; i++) {
        if (array[i].id === id)
        return true
    }
    return false
}

const extractStatusOptionsFromEntities = (entities, statusFilters) => {
    const filteredResponse = entities.filter(entity => entity.thresholdsExceeded.length > 0)
                                     .map(entity => entity.thresholdsExceeded)
                                     .reduce((result, thresholds) => result.concat(thresholds), [])
                                     .filter((threshold, index, allThresholds) => allThresholds.indexOf(allThresholds.find(at => at.id === threshold.id)) === index);

    var statusOptions = null

    if (statusFilters) {
        statusOptions = filteredResponse.map(threshold => ({id: threshold.id, icon: null, className: '', name: threshold.name, selected: containsID(statusFilters, threshold.id)}))
    } else {
        statusOptions = filteredResponse.map(threshold => ({id: threshold.id, icon: null, className: '', name: threshold.name, selected: true}))
    }

    statusOptions.push({id: -1, icon: null, className: '', token: 'normal', name: i18next.t('device-data-types.normal'), selected: true});
    statusOptions.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));

    return statusOptions;
};

const extractDataTypeOptionsFromEntities = (entities) => {
    const filteredResponse = entities.filter(entity => entity.currentMeasurements.length > 0)
                                     .map(entity => entity.currentMeasurements)
                                     .reduce((acc, val) => acc.concat(val), [])
                                     .map(currentMeasurement => currentMeasurement.lastReceivedData)
                                     .reduce((acc, val) => acc.concat(val), [])
                                     .filter(data => data)
                                     .map(data => data.deviceDataType)
                                     .filter(data => data.primary)
                                     .filter((datatype, index, allDatatypes) => allDatatypes.indexOf(allDatatypes.find(at => at.id === datatype.id)) === index);

    let datatypeOptions = filteredResponse.map(datatype => ({id: datatype.id, icon: null, className: '', name: i18next.t(`device-data-types.${datatype.token}`), selected: true}))

    datatypeOptions.push({id: -1, icon: null, className: "", token: 'other', name: i18next.t('device-data-types.other'), selected: true});
    datatypeOptions.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));

    return datatypeOptions;
};

export {
    extractAreaFilterOptionsFromEntities,
    extractStatusOptionsFromEntities,
    extractDataTypeOptionsFromEntities
};

